import { Autocomplete, Box, Button, CircularProgress, Grid, IconButton, Modal, TextField, Typography } from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import { CustomSnackbar } from "../../../../components/common/CustomSnackbar/CustomSnackbar";
import { Formik } from "formik";
import { useUbigeoStore } from "../../../../hooks/useUbigeoStore";
import { Department, District, Province } from "../../../../types/slices/ubigeoType";
import { useClientAddressStore } from "../../../../hooks/useClientAddressStore";
import { ApiStatus } from "../../../../types/api/status";
import { ClientAdress } from "../../../../types/slices/clientAdressType";
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    open: boolean
    onClose: () => void
    selectedClient: any
    addresses: ClientAdress[]
    setAddresses: React.Dispatch<React.SetStateAction<ClientAdress[]>>
}

interface FormData {
    address: string
    email?: string
    idclient: number
    alias?: string
    idcountry?: number | null
    iddepartment?: number | null
    idprovince?: number | null
    iddistrict: number | null
}

interface FormErrors {
    address?: string
    idclient?: string
    idcountry?: string
    iddepartment?: string
    idprovince?: string
    iddistrict?: string
}

export const ClientDirectionFormModal: FC<Props> = (props) => {
    const { open, onClose, selectedClient, addresses, setAddresses } = props

    const { getDepartments, getProvinces, getDistricts } = useUbigeoStore()
    const { status: statusClientAddress, createClientAddress } = useClientAddressStore()

    const [departments, setDepartments] = useState<Department[]>([])
    const [provinces, setProvinces] = useState<Province[]>([])
    const [districts, setDistricts] = useState<District[]>([])

    const [selectedDepartment, setSelectedDepartment] = useState<Department | null>(null)
    const [selectedProvince, setSelectedProvince] = useState<Province | null>(null)
    const [selectedDistrict, setSelectedDistrict] = useState<District | null>(null)

    const autocompleteRef = useRef<HTMLInputElement | null>(null)

    const data: FormData = {
        address: '',
        alias: '',
        idclient: selectedClient?.id,
        idcountry: null,
        iddepartment: null,
        idprovince: null,
        iddistrict: null
    }

    useEffect(() => {
        getDistrictsApi()
    }, [])

    // useEffect(() => {
    //     if (selectedDepartment) getProvincesApi(selectedDepartment?.id)
    // }, [selectedDepartment])

    // useEffect(() => {
    //     if (selectedProvince) getDistrictsApi(selectedProvince?.id)
    // }, [selectedProvince])

    const getDepartmentsApi = async () => {
        const departments = await getDepartments('', '1')
        setDepartments(departments || [])
    }

    const getProvincesApi = async (iddeparment) => {
        const provinces = await getProvinces('', iddeparment)
        setProvinces(provinces || [])
    }

    const getDistrictsApi = async () => {
        const districts = await getDistricts()
        setDistricts(districts || [])
        if (autocompleteRef.current) {
            const input = autocompleteRef.current.querySelector('input')
            if (input) input.focus()
        }
    }

    const validateForm = (values) => {
        let errors: FormErrors = {}

        if (!values.address) errors.address = "el campo es requerido"
        if (!values.idclient) errors.idclient = "el campo es requerido"
        // if (!values.idcountry) errors.idcountry = "el campo es requerido"
        // if (!values.iddepartment) errors.iddepartment = "el campo es requerido"
        // if (!values.idprovince) errors.idprovince = "el campo es requerido"
        if (!values.iddistrict) errors.iddistrict = "el campo es requerido"

        return errors
    }

    const onSubmit = async (values: FormData) => {
        const resp = await createClientAddress(values)
        if (resp?.id) {
            setAddresses([...addresses, resp])
            onClose()
        }
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Grid container spacing={2}
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2,
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    width: '500px',
                    boxShadow: 24,
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: '#000',
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (
                            <>
                                <Grid item xs={12}>
                                    <Typography id="modal-title" variant="h6" component="h2" sx={{ marginBottom: 2 }}>
                                        Registrar nueva dirección
                                    </Typography>
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <Autocomplete
                                        id="iddepartment"
                                        size="small"
                                        value={selectedDepartment || null}
                                        options={departments || []}
                                        getOptionLabel={(option) => option?.name || ''}
                                        isOptionEqualToValue={(option, value) => option.name === value?.name}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label="Región"
                                                size="small"
                                                error={errors.iddepartment && touched.iddepartment ? true : false}
                                                helperText={errors.iddepartment && touched.iddepartment ? errors.iddepartment : ''}
                                            />
                                        }
                                        onChange={(e, newValue: any) => {
                                            setSelectedDepartment(newValue)
                                            setFieldValue('iddepartment', newValue?.id || null);

                                            setSelectedProvince(null)
                                            setSelectedDistrict(null)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        id="idprovince"
                                        size="small"
                                        value={selectedProvince || null}
                                        options={provinces || []}
                                        getOptionLabel={(option) => option?.name || ''}
                                        isOptionEqualToValue={(option, value) => option.name === value?.name}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label="Provincia"
                                                size="small"
                                                error={errors.idprovince && touched.idprovince ? true : false}
                                                helperText={errors.idprovince && touched.idprovince ? errors.idprovince : ''}
                                            />
                                        }
                                        onChange={(e, newValue: any) => {
                                            setSelectedProvince(newValue)
                                            setFieldValue('idprovince', newValue?.id || null)

                                            setSelectedDistrict(null)
                                        }}
                                    />
                                </Grid> */}
                                <Grid item xs={12}>
                                    <Autocomplete
                                        ref={autocompleteRef}
                                        id="iddistrict"
                                        size="small"
                                        value={selectedDistrict || null}
                                        options={districts || []}
                                        getOptionLabel={(option) => option?.name +
                                            (option?.province?.name ? ' - ' + option?.province?.name : '') || ''}
                                        isOptionEqualToValue={(option, value) => option.name === value?.name}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label="Distrito"
                                                size="small"
                                                error={errors.iddistrict && touched.iddistrict ? true : false}
                                                helperText={errors.iddistrict && touched.iddistrict ? errors.iddistrict : ''}
                                            />
                                        }
                                        onChange={(e, newValue: any) => {
                                            setSelectedDistrict(newValue)
                                            setFieldValue('iddistrict', newValue?.id || null)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="address"
                                        fullWidth
                                        value={values.address}
                                        onChange={handleChange}
                                        label="Dirección"
                                        variant="outlined"
                                        size="small"
                                        error={errors.address && touched.address ? true : false}
                                        helperText={errors.address && touched.address ? errors.address : ''}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="alias"
                                        fullWidth
                                        value={values.alias}
                                        onChange={handleChange}
                                        label="Alias"
                                        variant="outlined"
                                        size="small"
                                        error={errors.alias && touched.alias ? true : false}
                                        helperText={errors.alias && touched.alias ? errors.alias : ''}
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ textAlign: 'right' }}>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            backgroundColor: '#91CBF9',
                                            color: '#fff',
                                            "&:hover": {
                                                backgroundColor: "#73B0E6",
                                            },
                                        }}
                                        onClick={() => handleSubmit()}
                                    >
                                        {statusClientAddress == ApiStatus.FETCHING && (
                                            <CircularProgress color="inherit" size={12} sx={{ color: '#fff', marginLeft: "10px" }} />
                                        )}
                                        Guardar
                                    </Button>
                                </Grid>
                            </>
                        )
                    }}
                </Formik>
            </Grid>
        </Modal>
    )
}